"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));
var _ImageGalleryDesktop = _interopRequireDefault(require("../ImageGalleryV2/ImageGalleryDesktop"));
var _ImageGalleryMobile = _interopRequireDefault(require("../ImageGalleryV2/ImageGalleryMobile"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AmenitiesCard = _interopRequireDefault(require("@airasia/phoenix-components/components/AmenitiesCard"));
var _RoomCard = require("../RoomCard/RoomCard.propTypes");
var ImageGalleryModalWrapper = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryModal__ImageGalleryModalWrapper",
  componentId: "sc-moivf8-0"
})(["#airasia-phoenix-modal-content{margin-top:", ";padding:", ";background-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.none;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.none;
}, function (_ref3) {
  var theme = _ref3.theme,
    isMobile = _ref3.isMobile;
  return !isMobile ? theme.backgroundColor.secondary : theme.backgroundColor.default;
});
var ImageGalleryModal = function ImageGalleryModal(_ref4) {
  var isMobile = _ref4.isMobile,
    images = _ref4.images,
    name = _ref4.name,
    amenities = _ref4.amenities,
    theme = _ref4.theme,
    onClose = _ref4.onClose,
    address = _ref4.address,
    allText = _ref4.allText,
    isOpen = _ref4.isOpen,
    zIndex = _ref4.zIndex,
    move = _ref4.move;
  return /*#__PURE__*/_react.default.createElement(ImageGalleryModalWrapper, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    openModal: isOpen,
    theme: theme,
    zIndex: zIndex,
    showCloseIcon: false,
    fullScreen: true,
    viewPort: "full_width"
  }, !isMobile ? /*#__PURE__*/_react.default.createElement(_ImageGalleryDesktop.default, {
    images: images,
    onClose: onClose,
    customProperties: {
      isHorizontalScroll: true
    },
    roomDetail: {
      name: name,
      amenities: /*#__PURE__*/_react.default.createElement(_AmenitiesCard.default, {
        accessible: true,
        amenities: amenities,
        iconColor: move ? 'greyDarker' : 'greyLight',
        textColor: move ? 'greyDarker' : 'greyLight',
        twoColumns: true
      })
    },
    theme: theme,
    move: move
  }) : /*#__PURE__*/_react.default.createElement(_ImageGalleryMobile.default, {
    images: images,
    hotelDetail: {
      name: name,
      address: address
    },
    onClose: onClose,
    allLabel: allText,
    isRoomDetail: true,
    move: move,
    theme: theme
  })));
};
ImageGalleryModal.propTypes = _RoomCard.ImageGalleryModalPropTypes;
ImageGalleryModal.defaultProps = _RoomCard.ImageGalleryModalDefaultValues;
var _default = ImageGalleryModal;
exports.default = _default;